import React from 'react';
import StatusBadge from './StatusBadge';

interface MsStatusProps {
  id?: string | number;
  status: 'FAILED' | 'RUNNING' | 'STOPPED' | 'CONFIGURING';
}

const Status = (props: MsStatusProps) => {
  let titleCase = '';
  switch (props.status) {
    case 'FAILED':
      titleCase = 'Failed';
      break;
    case 'RUNNING':
      titleCase = 'Running';
      break;
    case 'STOPPED':
      titleCase = 'Stopped';
      break;
    case 'CONFIGURING':
      titleCase = 'Configuring';
      break;
  }

  return <StatusBadge variant={props.status as any} text={titleCase}></StatusBadge>;
};

export default Status;
